import LegalPage from '../components/LegalPage';

function TermsAndConditions() {
  return (
    <LegalPage title="Terms & Conditions" updated="June 2026">
      <p>
        These Terms &amp; Conditions (&ldquo;Terms&rdquo;) govern your access to and use of the
        websites <strong>bhavanidc.com</strong> and <strong>bhavanidiecasting.com</strong> (together,
        the &ldquo;Website&rdquo;), operated by Bhavani Die Casting Private Limited (&ldquo;Bhavani Die
        Casting&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;, or &ldquo;our&rdquo;). By accessing or using
        the Website, you agree to be bound by these Terms. If you do not agree, please do not use the
        Website.
      </p>

      <h2>1. Use of the Website</h2>
      <p>
        The Website is provided for general information about our die casting capabilities, products,
        and services. You agree to use it lawfully and not to misuse it, interfere with its operation,
        or attempt unauthorised access to any part of it or its underlying systems.
      </p>

      <h2>2. Intellectual Property</h2>
      <p>
        All content on the Website — including the Bhavani Die Casting name, logo, text, graphics,
        images, and design — is owned by or licensed to us and is protected by applicable intellectual
        property laws. You may not reproduce, distribute, or use any content for commercial purposes
        without our prior written consent.
      </p>

      <h2>3. Product &amp; Service Information</h2>
      <p>
        Information about our processes, machinery, capabilities, materials, tolerances, and capacities
        is provided for general guidance only. It does not constitute a binding offer or a guarantee of
        suitability for any specific application. Actual products, specifications, and commercial terms
        are governed solely by the formal quotation, purchase order, and agreement executed between the
        parties.
      </p>

      <h2>4. Enquiries &amp; Quotations</h2>
      <p>
        Any enquiry submitted through the Website or by email does not create a contract. A binding
        commitment arises only upon a written quotation issued by us and a corresponding purchase order
        accepted in accordance with our standard terms of sale.
      </p>

      <h2>5. Confidentiality</h2>
      <p>
        Technical drawings, designs, specifications, and commercial information exchanged between you
        and us are treated as confidential and used only for the purpose of evaluating and fulfilling
        your requirement. We expect the same standard of confidentiality with respect to any
        proprietary information we share with you.
      </p>

      <h2>6. Disclaimer of Warranties</h2>
      <p>
        The Website and its content are provided on an &ldquo;as is&rdquo; and &ldquo;as
        available&rdquo; basis, without warranties of any kind, whether express or implied. We do not
        warrant that the Website will be uninterrupted, error-free, or free of harmful components, or
        that the information it contains is complete, accurate, or current.
      </p>

      <h2>7. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, Bhavani Die Casting shall not be liable for any
        indirect, incidental, special, or consequential damages, or any loss of profits, data, or
        business, arising out of or in connection with your use of, or inability to use, the Website.
      </p>

      <h2>8. Third-Party Links</h2>
      <p>
        The Website may contain links to third-party websites for convenience. We do not control and
        are not responsible for the content, products, or practices of those websites.
      </p>

      <h2>9. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless Bhavani Die Casting and its directors, employees, and
        representatives from any claims, damages, or expenses arising from your misuse of the Website or
        breach of these Terms.
      </p>

      <h2>10. Governing Law &amp; Jurisdiction</h2>
      <p>
        These Terms are governed by the laws of India. Any disputes arising in connection with the
        Website or these Terms shall be subject to the exclusive jurisdiction of the courts at
        Chhatrapati Sambhajinagar (Aurangabad), Maharashtra, India.
      </p>

      <h2>11. Changes to These Terms</h2>
      <p>
        We may revise these Terms at any time. Updated Terms will be posted on this page with a revised
        &ldquo;Last updated&rdquo; date, and your continued use of the Website constitutes acceptance of
        the changes.
      </p>

      <h2>12. Contact Us</h2>
      <p>For any questions about these Terms, please contact us:</p>
      <p className="mb-0">
        <strong>Bhavani Die Casting Private Limited</strong><br />
        Plot No. 36, Sector-16, DMIC, Bidkin,<br />
        District Chhatrapati Sambhajinagar (Aurangabad), Maharashtra - 431105, India<br />
        Email: <a className="link-brand" href="mailto:contact@bhvanidc.com">contact@bhvanidc.com</a><br />
        Phone: <a className="link-brand" href="tel:+919545130777">+91 9545130777</a>
      </p>
    </LegalPage>
  );
}

export default TermsAndConditions;
